<form [formGroup]="anulacionBheFormGroup" (ngSubmit)="onSubmit()" #localFormRef="ngForm">
	<div class="modal-body">
		<div class="form-group position-relative mx-auto">
			<div class="row" *ngIf="bheEmitida">
				<table class="table ml-3">
					<tr>
						<td>RUT</td>
						<td>{{ bheEmitida.rutReceptor }}-{{ bheEmitida.dvReceptor }}</td>
						<td>FOLIO</td>
						<td>{{ bheEmitida.folio }}</td>
					</tr>
					<tr>
						<td>RAZÓN SOCIAL</td>
						<td>{{ bheEmitida.nombreReceptor }}</td>
						<td>FECHA EMISIÓN</td>
						<td>{{ bheEmitida.fechaEmision | date : "dd/MM/yyyy" }}</td>
					</tr>
					<tr>
						<td>TOTAL</td>
						<td>{{ bheEmitida.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</td>
						<td>LÍQUIDO A PAGAR</td>
						<td>{{ bheEmitida.liquido | currency : "$ " : "symbol" : "1.0-0" : "es" }}</td>
					</tr>
				</table>
			</div>
		</div>
		<div class="form-group position-relative mx-auto">
			<div class="row">
				<label for="" class="col-3 label-control">Motivo de Anulación</label>
				<div class="col-9">
					<ng-select [items]="anulacionBheSource" bindLabel="nombre" [clearable]="false" formControlName="motivoAnulacion"></ng-select>
					<div *ngIf="(localFormRef.submitted || localFormRef.touched) && this.anulacionBheFormGroup.get('motivoAnulacion').invalid" class="text-danger">
						<div>Campo Requerido</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
			<i class="la la-paper-plane-o d-lg-none"></i>
			<span class="d-none d-lg-block">Guardar</span>
		</button>
		<button type="button" class="btn btn-secondary ml-3" (click)="sendCloseRequest()">
			<span class="d-none d-lg-block">Cerrar</span>
		</button>
	</div>
</form>
